
export class OrderValidationSerializer {
  static deserialize = data => ({
    icdMatchesDiagnosis: data.icd_matches_diagnosis,
  });
}
